<div class="sidebar-brand">
  <a routerLink="/dashboard">
    <div class="row align-items-center">
      <div class="col-auto">
        <img class="sc-logo" alt="skillconomy" src="assets/img/fav.ico" />
      </div>
      <div class="col ps-0">
        <div class="smaller text-muted" style="line-height: 1;">skillconomy</div>
      </div>
    </div>

  </a>
</div>

<nav class="sidebar-nav nav flex-column">

  <a class="nav-link" routerLink="/dashboard" routerLinkActive="is-active">
    <span class="icon">
      <i class="fa-sharp fa-solid fa-square-poll-horizontal fa-xs"></i>
    </span>
    <span class="label">{{ texts.dashboard | localize }}</span>
  </a>

  <a class="nav-link" routerLink="/projects" *ngIf="projectCount">
    <span class="icon">
      <i class="fa-sharp fa-solid fa-window-restore fa-xs"></i>
    </span>
    <span class="label">{{ texts.positions | localize }}</span>
  </a>

  <div class="nav flex-column sidebar-subnav" *ngIf="projectCount">

    <a class="nav-link" routerLink="/projects" [queryParams]="{ status: 'Imported' }" routerLinkActive="is-active"
      [routerLinkActiveOptions]="statusLinkOptions">
      <span class="label">{{ texts.positionsImported | localize }}</span>
    </a>

    <a class="nav-link" routerLink="/projects" [queryParams]="{ status: 'AnalysisRequested' }" routerLinkActive="is-active"
      [routerLinkActiveOptions]="statusLinkOptions">
      <span class="label">{{ texts.positionsAnalysisRequested | localize }}</span>
      <span class="badge badge-pill badge-light ms-auto" *ngIf="analysisRequestedCount">{{ analysisRequestedCount }}</span>
    </a>

    <a class="nav-link" routerLink="/projects" [queryParams]="{ status: 'AwaitingOrder' }" routerLinkActive="is-active"
      [routerLinkActiveOptions]="statusLinkOptions">
      <span class="label">{{ texts.positionsPrepared | localize }}</span>
      <span class="badge badge-pill badge-danger ms-auto" *ngIf="preparedProjectCount">{{ preparedProjectCount
        }}</span>
    </a>

    <a class="nav-link" routerLink="/projects" [queryParams]="{ status: 'Sourcing', type: 'Longlist' }"
      routerLinkActive="is-active" [routerLinkActiveOptions]="statusLinkOptions">
      <span class="label">{{ texts.positionsLonglists | localize }}</span>
      <!-- <span class="badge badge-pill badge-light ms-auto">5</span> -->
    </a>

    <a class="nav-link" routerLink="/projects" [queryParams]="{ status: 'Sourcing', type: 'Full' }"
      routerLinkActive="is-active" [routerLinkActiveOptions]="statusLinkOptions">
      <span class="label">{{ texts.positionsOutreach | localize }}</span>
      <!-- <span class="badge badge-pill badge-light ms-auto">8</span> -->
    </a>

  </div>

  @if(demo.isActive)
  {
  <a class="nav-link" routerLink="/pool" routerLinkActive="is-active">
    <span class="icon">
      <i class="fa-sharp fa-solid fa-users fa-xs"></i>
    </span>
    {{ texts.pool | localize }}
  </a>
  }

  <!-- 

  <a class="nav-link" routerLink="/reporting" routerLinkActive="is-active">
    <span class="icon">
      <i class="fa-sharp fa-solid fa-chart-simple fa-xs"></i>
    </span>
    {{ texts.reporting | localize }}
  </a> -->

</nav>

<div class="sidebar-footer">

  <a class="nav-link" [class.d-none]="userService?.me?.Settings?.DisableNotifications == true"
    (click)="notificationsModal.show()">
    <span class="icon">
      <i class="fa-sharp fa-solid fa-bell fa-xs"></i>
    </span>
    <span class="label">{{ texts.notifications | localize }}</span>
    <span *ngIf="notifications.items?.length" class="badge badge-pill badge-danger ms-2">{{ notifications.items?.length
      }}</span>
  </a>

  <div class="sidebar-user" tabindex="0">

    <!-- slides up out of the user row on hover, over the links above it -->
    <div class="sidebar-user-menu">
      <div class="sidebar-user-menu-inner">
        <a class="nav-link fw-normal" routerLink="/settings" routerLinkActive="is-active">
          <span class="icon" style="transform: none !important;">
            <i class="fa-sharp fa-solid fa-gear"></i>
          </span>
          <span class="label">{{ texts.settings | localize }}</span>
        </a>

        <a class="nav-link fw-normal" (click)="logout()">
          <span class="icon">
            <i class="fa-sharp fa-solid fa-arrow-right-from-bracket"></i>
          </span>
          <span class="label">{{ texts.logout | localize }}</span>
        </a>
      </div>
    </div>

    <div class="user">
      <sc-avatar size="sm" [user]="userService.me"></sc-avatar>
      <span class="user-name oneline">{{ userService.me?.FirstName }} {{ userService.me?.LastName }}</span>
    </div>
  </div>
</div>

<app-notifications-modal #notificationsModal [items]="notifications.items" [language]="loc.language"
  (itemClick)="navigateItem($event)"></app-notifications-modal>